import { Box, Container, Typography } from '@mui/material';
import styles from './footer.module.css';
import isMobile from '../components/mobile/useInMobile';
import PtechLogoWhite from '@/assets/PROMPT_TECHNOLOGY_LOGO_white.png';
export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        bgcolor: 'black',
      }}
    >
      {/* 콘텐츠 폭·좌우 패딩을 Top Nav(1240/32)와 동일하게 맞춘다.
          disableGutters 로 MUI 기본 거터(24px)를 제거한 뒤 32px 패딩을 직접 적용한다. */}
      <Container disableGutters maxWidth={false} sx={{ maxWidth: '1240px', mx: 'auto', px: '32px' }}>
        <Box
          className="footer"
          justifyContent={{ sm: 'start', xs: 'start', md: 'center', lg: 'space-between' }}
          sx={{
            display: 'flex',
            flexDirection: isMobile() ? 'column' : 'row',
          }}
        >
          <Box className="footer-image-wrap">
            <img className="footer-image" src={PtechLogoWhite} />
          </Box>
          <Box className="footer-text-wrap">
            <Typography className="footer-name-text">(주)프람트테크놀로지</Typography>
            <Typography className="footer-address-text">대표이사 : 전종훈</Typography>
            <Typography className="footer-address-text">
              서울특별시 강남구 논현로81길 12, 2층(역삼동, 조앤리빌딩)
            </Typography>
            <Typography className="footer-address-text">Tel: (02)553-6441</Typography>
            <Typography className="footer-address-text">Fax: (02)553-6442</Typography>
            <Typography className="footer-copyright-text">
              Copyright © 2011, by Prompt Technology, Co., Ltd. All Rights Reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
